<template>
<main>
  <dl>
    <dt>
      <span>项目</span>
      <span>单价</span>
      <span>数量</span>
      <span>备注</span>
    </dt>
    <dd v-for="(v, i) in list" :key="i">
      <select name="" id="" v-model="v.item">
        <option value="0">请选择</option>
        <option :value="v.id" v-for="v in visaFees" :key="v.id">{{ v.text }}</option>
      </select>
      <input v-model="v.unit_price" step="0.01" type="number" placeholder="请输入" @change="changePrice(i)"/>
      <div class="count">
        <i class="icon-jian1" @click="changeCount(i, -1)"></i>
        <span>{{ v.count }}</span>
        <i class="icon-jia" @click="changeCount(i, 1)"></i>
      </div>
      <input v-model="v.remark" type="text" placeholder="请输入"/>
    </dd>
  </dl>
  <p class="total"><span>合计：</span><b>{{total}}</b></p>
  <button @click="addOption">添加项目</button>
  <footer @click="save">保存</footer>
</main>
</template>

<script>
export default {
  data () {
    return {
      visaFees: [],
      list: [
        {
          item: 0,
          count: 1,
          unit_price: null,
          remark: null
        }
      ]
    }
  },
  computed: {
    adjectiveList () {
      return this.list.filter(v => v.count && v.item && v.unit_price);
    },
    total () {
      const total = this.adjectiveList.reduce((total, v) => {
        total += (v.unit_price || 0) * v.count;
        return total;
      }, 0);
      return parseFloat(total.toFixed(2));
    }
  },
  async created () {
    const { visa_fees } = await this.visCache();
    this.visaFees = visa_fees;
  },
  methods: {
    save () {
      const list = this.adjectiveList;
      if ( list.length === 0 ) { this.$toast('格式有误，请检查！'); return; }
      sessionStorage.setItem('otherPrice', JSON.stringify(list));
      this.$router.back();
    },
    changePrice (index) {
      let list = [...this.list];
      const price = Number(list[index].unit_price) || 0;
      list[index].unit_price = price;
      this.list = list;
    },
    changeCount (index, val) {
      let list = [...this.list];
      list[index].count = Number(list[index].count) + val;
      if ( list[index].count <= 0 ) {
        list[index].count = 1;
      }
      this.list = list;
    },
    addOption () {
      this.list = [...this.list, {
        item: 0,
        count: 1,
        unit_price: null,
        remark: null
      }];
    }
  }
}
</script>

<style scoped src="./otherPrice.css"></style>